(() => {
  const GIFT_VARIANT_ID = 57638639206787;
  const GIFT_QTY = 1;

  let isSyncingGift = false;
  let syncTimeout = null;

  function rootUrl(path) {
    return `${window.Shopify.routes.root}${path}`;
  }

  async function getCart() {
    const res = await fetch(rootUrl('cart.js'), {
      credentials: 'same-origin'
    });

    if (!res.ok) {
      throw new Error('Nepodařilo se načíst košík.');
    }

    return await res.json();
  }

  async function addGift() {
    const res = await fetch(rootUrl('cart/add.js'), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      credentials: 'same-origin',
      body: JSON.stringify({
        items: [
          {
            id: GIFT_VARIANT_ID,
            quantity: GIFT_QTY,
            properties: {
              '_auto_free_gift': 'true'
            }
          }
        ]
      })
    });

    if (!res.ok) {
      const text = await res.text();
      throw new Error(`Nepodařilo se přidat dárek: ${text}`);
    }

    return await res.json();
  }

  async function changeLine(line, quantity) {
    const res = await fetch(rootUrl('cart/change.js'), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      credentials: 'same-origin',
      body: JSON.stringify({
        line,
        quantity
      })
    });

    if (!res.ok) {
      const text = await res.text();
      throw new Error(`Nepodařilo se upravit košík: ${text}`);
    }

    return await res.json();
  }

  function getGiftLine(cart) {
    return cart.items.find((item) => item.variant_id === GIFT_VARIANT_ID);
  }

  function getGiftLineIndex(cart) {
    return cart.items.findIndex((item) => item.variant_id === GIFT_VARIANT_ID);
  }

  function getNormalItems(cart) {
    return cart.items.filter((item) => item.variant_id !== GIFT_VARIANT_ID);
  }

  function isGiftLast(cart) {
    if (!cart.items.length) return false;
    return cart.items[cart.items.length - 1].variant_id === GIFT_VARIANT_ID;
  }

  async function moveGiftToEnd() {
    const cart = await getCart();
    const giftLineIndex = getGiftLineIndex(cart);

    if (giftLineIndex === -1) return;

    await changeLine(giftLineIndex + 1, 0);
    await addGift();
  }

  async function ensureGiftIsLast() {
    const cart = await getCart();
    const giftLine = getGiftLine(cart);

    if (!giftLine) return;

    if (!isGiftLast(cart)) {
      await moveGiftToEnd();
    }
  }

  async function syncFreeGift() {
    if (isSyncingGift) return;
    isSyncingGift = true;

    try {
      let cart = await getCart();
      let giftLine = getGiftLine(cart);
      const normalItems = getNormalItems(cart);

      const shouldHaveGift = normalItems.length > 0;

      if (shouldHaveGift && !giftLine) {
        await addGift();

        await new Promise((resolve) => setTimeout(resolve, 250));

        cart = await getCart();
        giftLine = getGiftLine(cart);

        if (giftLine && !isGiftLast(cart)) {
          await moveGiftToEnd();
        }

        return;
      }

      if (!shouldHaveGift && giftLine) {
        const giftLineIndex = getGiftLineIndex(cart);

        if (giftLineIndex !== -1) {
          await changeLine(giftLineIndex + 1, 0);
          return;
        }
      }

      if (giftLine && giftLine.quantity !== GIFT_QTY) {
        const giftLineIndex = getGiftLineIndex(cart);

        if (giftLineIndex !== -1) {
          await changeLine(giftLineIndex + 1, GIFT_QTY);
          return;
        }
      }

      if (giftLine && !isGiftLast(cart)) {
        await moveGiftToEnd();
        return;
      }
    } catch (e) {
      console.error('Free gift sync error:', e);
    } finally {
      isSyncingGift = false;
    }
  }

  function scheduleSync(delay = 400) {
    clearTimeout(syncTimeout);
    syncTimeout = setTimeout(() => {
      syncFreeGift();
    }, delay);
  }

  const originalFetch = window.fetch;
  window.fetch = async function (...args) {
    const response = await originalFetch.apply(this, args);

    try {
      const requestUrl =
        typeof args[0] === 'string'
          ? args[0]
          : args[0] && args[0].url
            ? args[0].url
            : '';

      if (
        requestUrl.includes('/cart/add') ||
        requestUrl.includes('/cart/change') ||
        requestUrl.includes('/cart/update') ||
        requestUrl.includes('/cart/clear')
      ) {
        scheduleSync(500);
      }
    } catch (e) {
      console.error('Free gift fetch hook error:', e);
    }

    return response;
  };

  document.addEventListener('DOMContentLoaded', () => {
    scheduleSync(300);
  });

  document.addEventListener('submit', (e) => {
    const form = e.target;
    if (form && form.matches('form[action*="/cart/add"]')) {
      scheduleSync(500);
    }
  });

  window.addEventListener('pageshow', () => {
    scheduleSync(300);
  });

  window.addEventListener('freegift:force-sync', () => {
    scheduleSync(100);
  });
})();